import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/login/page.js");
